import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=46ea79c4&scoped=true&"
import script from "./InputArea.vue?vue&type=script&lang=ts&"
export * from "./InputArea.vue?vue&type=script&lang=ts&"
import style0 from "./InputArea.vue?vue&type=style&index=0&id=46ea79c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea79c4",
  null
  
)

export default component.exports